import { InfoCard } from '../InfoCard/InfoCard';
import { CalendarIcon, Heading, Text } from '@weave/design-system';
import { childStyles } from './styles';

type InsurancePayerMixTotalAppointmentProps = {
  totalCount: number;
};

export const InsurancePayerMixTotalAppointment = ({
  totalCount,
}: InsurancePayerMixTotalAppointmentProps) => {
  return (
    <InfoCard title="Total Appointments">
      <div css={childStyles}>
        <CalendarIcon size={30} />
        <Heading level={2} css={{ margin: 0 }}>
          {totalCount}
        </Heading>
        <Text size="small" css={{ margin: 0 }}>
          next 30 days
        </Text>
      </div>
    </InfoCard>
  );
};
